import React from 'react';
import {connect} from 'react-redux';
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import css from './LayersPanel.module.css';
import * as filterActions from '../../../../store/filterSlice';
import Checkbox from "@material-ui/core/Checkbox";
import {StopOverlayTypes, StopQuestLevels, StopGruntLevels} from "../../../../store/filterSlice";
import {fetchData} from "../../../../store/coreSlice";

const StopControls = (props) => {
	const onChangeStopOverlay = (event) => {
		props.setStopOverlay(event.target.value);
		// if( !props.stopShowAll ) {// If true, we already have all
		// 	console.log("Need to grab all stops...");
		// 	props.fetchData(false);
		// }
	};

	return (
		<div className={css.Panel}>
			<div className={css.Title}>PokéStops</div>

			<FormControl className={css.FormElement}>
				<InputLabel>PokéStop Overlay</InputLabel>

				<Select value={props.stopOverlay} onChange={onChangeStopOverlay}>
					<MenuItem value={StopOverlayTypes.QUEST}>Quests</MenuItem>
					<MenuItem value={StopOverlayTypes.LURE}>Lures</MenuItem>
					<MenuItem value={StopOverlayTypes.GRUNT}>Grunts</MenuItem>
					<MenuItem value={StopOverlayTypes.NONE}>None</MenuItem>
				</Select>
			</FormControl>

			{props.stopOverlay === StopOverlayTypes.LURE &&
				<FormControl className={css.FormElement}>
					<FormControlLabel control={(
						<Checkbox
							checked={props.stopLureOnlySpecial}
							onChange={() => props.toggleFeature('stopLureOnlySpecial')}
						/>
					)} label={'Show Only Special Lures'} />
				</FormControl>
			}

			{props.stopOverlay === StopOverlayTypes.QUEST &&
			<FormControl className={css.FormElement}>
				<InputLabel>Quest Quality</InputLabel>

				<Select value={props.stopQuestLevel} onChange={(e) => props.setStopQuestLevel(e.target.value)}>
					<MenuItem value={StopQuestLevels.ALL}>All Quests</MenuItem>
					<MenuItem value={StopQuestLevels.GOOD}>Good Quests</MenuItem>
					<MenuItem value={StopQuestLevels.BEST}>Best Quests</MenuItem>
				</Select>
			</FormControl>
			}

			{props.stopOverlay === StopOverlayTypes.GRUNT &&
			<FormControl className={css.FormElement}>
				<InputLabel>Quest Quality</InputLabel>

				<Select value={props.stopGruntLevel} onChange={(e) => props.setStopGruntLevel(e.target.value)}>
					<MenuItem value={StopGruntLevels.ALL}>Grunts and Leaders</MenuItem>
					<MenuItem value={StopGruntLevels.ONLY_GRUNTS}>Only Grunts</MenuItem>
					<MenuItem value={StopGruntLevels.ONLY_LEADERS}>Only Leaders</MenuItem>
					<MenuItem value={StopGruntLevels.ONLY_GIOVANNI}>Only Giovanni</MenuItem>
				</Select>
			</FormControl>
			}

			<FormControl className={css.FormElement}>
				<FormControlLabel control={(
					<Checkbox checked={props.stopShowAll} onChange={() => props.toggleFeature('stopShowAll')} />
				)} label={'Show All Stops'} />
			</FormControl>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		stopOverlay: state.filter.stopOverlay,
		stopLureOnlySpecial: state.filter.stopLureOnlySpecial,
		stopQuestLevel: state.filter.stopQuestLevel,
		stopGruntLevel: state.filter.stopGruntLevel,
		stopShowAll: state.filter.stopShowAll,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		toggleFeature: (val) => dispatch(filterActions.toggleFeature(val)),
		setStopOverlay: (val) => dispatch(filterActions.setStopOverlay(val)),
		setStopQuestLevel: (val) => dispatch(filterActions.setStopQuestLevel(val)),
		setStopGruntLevel: (val) => dispatch(filterActions.setStopGruntLevel(val)),
		fetchData: (onlyNew) => dispatch(fetchData(onlyNew)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(StopControls);